export class KillAfterAnimation {}
